import React from "react";
import InsightsContainer from "../../containers/Insights";

function Insights(props) {
  return <InsightsContainer {...props} />;
}

export default Insights;
